<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
          <div class="auth-heading">
            <h1>Terms Conditions</h1>
            <p class="auth-subtext">Read carefully</p>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
          </div>
        </div>
      <div
          v-if="userRole === 'pharmacy' || routeName === 'terms_and_conditions2' || routeName === 'terms_and_conditions_guest_shift'"
      >
        <div class="page_title">
          PHARMACY TERMS OF ACCESS FOR THE LOCUMATE PLATFORM
        </div>
        <div>
          Last updated: June 01, 2023
          <br/>
          <br/>
          Please read these terms and conditions carefully before using Our
          Service.
          <br/>
          <br/>
          These terms apply to all Locumate Services you access through the Locumate Platform.
          <br/>
          <br/>
          We operate an online system which connects Pharmacies to Locums looking for work.
          <br/>
          <br/>
          These Terms of Access constitute an agreement between us and you. By registering with Locumate and continuing to
          use the Locumate Platform, you are deemed to have read, understood and accepted these Terms of Access.
          <br/>
          <br/>
          We reserve the right to amend these Terms of Access from time to time. We will use our reasonable endeavours to
          draw your attention to such amendments (for example, by email or placing a notice on our website), however it
          remains your responsibility to periodically review these Terms of Access. You acknowledge and agree that your
          continued use of Locumate Services after any changes to these Terms of Access will be deemed by us to be your
          acceptance of any amendments.
          <br/>
          <br/>
          Any questions about these Terms of Access or requests for technical assistance may be sent to
          <a href="mailto:support@locumate.com.au">support@locumate.com.au.</a>
          Alternatively, call us on <a href="tel: 0391207780">03 9120 7780.</a>
          <br/>
          <br/>
          <h4 class="title">AGREEMENT TERMS</h4>
          <br/>
          <h3 class="title uppercase"><span class="main_point">1</span> locumate platform account</h3>
          <div>
            <span class="secondary_point">1.1 </span>To access the Locumate Services, you must create an account with us
            by:
            <br/>
            <br/>
            <div class="tertiary_align">
              <span class="tertiary_point">1.1.1 </span>
              <div class="tertiary_content">
                providing the information requested by us; and
              </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.1.2</span><div class="tertiary_content"> creating a password that meets our minimum requirements.</div>
            </div>
            <br/>
            <span class="secondary_point">1.2 </span> You acknowledge and agree that:
            <br/>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.1</span> <div class="tertiary_content">you are responsible for ensuring all information you provide us is
            correct and up to date, including without
            limitation, the details of the Pharmacy;
            </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.2</span> <div class="tertiary_content">you are responsible for the activity that occurs on your account;</div>
            </div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.3</span><div class="tertiary_content"> you must take all necessary steps to protect your User ID, password
            and account from unauthorised access; and</div>
          </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.4</span> <div class="tertiary_content"> you will immediately notify us if:</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span> <div class="tertiary_content">the information you have provided is incorrect, inaccurate or
            incomplete; or</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span> <div class="tertiary_content">you become aware of or suspect that your User ID, password or account
            is being used or may have been accessed
            without your consent;</div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.5</span> <div class="tertiary_content">you must not use the Locumate Platform for an illegal purpose or in
            a manner that is inconsistent with these
            Terms of Access; and</div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.6</span> <div class="tertiary_content">you must not supply or upload any content that: (i) would cause you
            or Locumate to breach any law, regulation
            or code of conduct; (ii) is or could reasonably considered to be obscene, inappropriate, defamatory,
            disparaging, indecent, seditious, offensive, pornographic, threatening, abusive, liable to incite racial
            hatred, discriminatory, blasphemous, in breach of confidence or in breach of privacy; or (iii) that could
            infringe any person’s rights, including their intellectual property.</div></div>
            <br>
          </div>
          <h3 class="title uppercase"><span class="main_point">2</span> locumate SERVICES</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">2.1 </span> If you create an account with us, we will provide Locumate Services
            to you. These are technology,
            communication and administration services to enable you to use the Locumate Platform to be connected with
            Locums based on the Pharmacy’s needs.
          </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.2 </span> The Pharmacy will also have a separate relationship with any Locum
            who is placed with the Pharmacy. The Locum
            is responsible for providing the Pharmacy Services to the Pharmacy directly in accordance with the Standard
            Terms of Engagement.
          </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.3 </span> Locumate does not provide Pharmacy Services or employ or engage
            Locums. Locums do not work for Locumate. All
            Locums who use the Locumate Platform practise independently.
          </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.4 </span> Locumate Services include but are not limited to:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">2.4.1</span> <div class="tertiary_content">A website and mobile application which provides a platform that
            performs functions such as:</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span> <div class="tertiary_content">allowing you to create an account on the Locumate Platform;</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span> <div class="tertiary_content">enabling you to lodge a request for Pharmacy Services required by the
            Pharmacy, including specifying the
            details of the location, dates and times the Pharmacy Services are required and associated fees;</div></div>
            <br>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(c)</span> <div class="tertiary_content">matching Pharmacies with Locums who respond to a request for Pharmacy
            Services which meet the criteria of the
            Pharmacy;</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(d)</span> <div class="tertiary_content">paying the Locum for Pharmacy Services;</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(e)</span> <div class="tertiary_content">providing the PayNow Service;</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(f)</span> <div class="tertiary_content">paying Locumate for Locumate Services; and</div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">2.4.2</span> <div class="tertiary_content">technical support services.</div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">3</span> your responsibilities</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">3.1 </span>To use the Locumate Platform, you warrant that you:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.1</span> <div class="tertiary_content">are 18 years or over; </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.2</span> <div class="tertiary_content">are the owner or authorised representative of the Pharmacy; </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.3</span> <div class="tertiary_content">will ensure that the Pharmacy has and maintains, without any
            suspension, restriction or limitation, all
            Approvals necessary to operate the Pharmacy in accordance with all applicable laws; and </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.4</span> <div class="tertiary_content">will provide us with copies of all Approvals referred to in clause
            3.1.3 upon request. </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">3.2 </span> You must immediately notify us of any changes to the Pharmacy’s
            Approvals or if any condition or other
            restriction is imposed on the Pharmacy which restricts its ability to operate. You acknowledge that we may
            immediately suspend your account and refuse the Pharmacy access to Locumate Services as a result of any
            changes to the Pharmacy’s Approvals.</div>
            <br/>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">4</span> requesting pharmacy services</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">4.1 </span> You may use the Locumate Platform to request Pharmacy Services. To
            request Pharmacy Services, you must specify
            the location where the Pharmacy Services are required, the dates and times the Pharmacy Services are required,
            the hourly rate (including any applicable superannuation) which the Pharmacy is willing to pay for the
            Pharmacy Services and any other information required by the Locumate Platform.
          </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.2 </span> The Locumate Platform keeps all information uploaded by you and
            Locums confidential. The Locumate Platform
            will not disclose any information (for example, rates for Pharmacy Services) to another party but will match
            you to a Locum if one has specified that they meet your criteria.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.3 </span> You acknowledge that we will only notify Locums of your request who
            have indicated that they are willing to
            travel to the location of the Pharmacy and provide Pharmacy Services for the hourly rate you have specified.
            If there are no Locums who meet your criteria, we will not be able to connect you to a Locum.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.4 </span> The Locum who first accepts your request for Pharmacy Services will
            be placed with the Pharmacy and details
            provided to enable you to connect to the Locum. The Locumate Platform will not provide you with any further
            alternatives or available Locums.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.5 </span>The Locum will provide the Pharmacy Services to you directly. If a
            Locum is placed with you, a binding
            contract will be formed between you and the Locum on the Standard Terms of Engagement at the time we notify
            you of the placement. You are free to negotiate with the Pharmacy changes to the Standard Terms of Engagement.
            You acknowledge that:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.5.1</span> <div class="tertiary_content">Locumate is not a party to any contract between the Locum and
            Pharmacy; and </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.5.2</span> <div class="tertiary_content">Locumate does not provide tax, contract, commercial or employment
            advice as to the engagement of Locums by
            Pharmacies or warrant or represent that the Standard Terms of Engagement are suitable for your purposes.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.6 </span> It is a condition of using the Locumate Platform that Locums have
            specialist registration as a pharmacist with
            the Pharmacy Board of Australia and the Australian Health Practitioner Regulation Agency (AHPRA). It is your
            responsibility to ensure that the Locum is appropriately skilled and qualified to provide the Pharmacy
            Services to you.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.7 </span> You acknowledge and agree that for the duration that the Locum is
            placed at your Pharmacy, the Pharmacy is
            responsible for:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.7.1</span> <div class="tertiary_content">complying with all applicable laws and contractual obligations
            relating to the operation of the Pharmacy
            (which may or may not allow the use of locums);
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.7.2</span><div class="tertiary_content"> ensuring the Locum provides the Pharmacy Services with an
            appropriate level of skill, care and diligence and
            in compliance with all applicable laws; and
            </div>
           </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.7.3</span><div class="tertiary_content"> ensuring the Pharmacy is free from workplace health and safety
            risks, and providing the Locum with appropriate
            training and access to the Pharmacy’s workplace policies and procedures.
          </div>
          </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.8 </span> You must immediately notify us in writing if you become aware of any
            event or circumstance in relation to the
            Locum or Pharmacy Services which could reasonably be expected to directly or indirectly harm or diminish
            confidence in and/or the standing or reputation of Locumate, the Locum, the Pharmacy or the Pharmacy Services.
          </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">5</span> cancellation</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">5.1 </span> You may cancel an Engagement by giving the Locum not less than 72 hours’
            notice of cancellation before the start of the Shift, using the cancellation function on the Locumate Platform.
            If you cancel an Engagement within 72 hours, you must pay us a cancellation fee of $50 and the
            locum 50% of the locums shift fee.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">5.2 </span> The Locum may cancel an Engagement by giving you not less than 72
            hours’ notice of cancellation before the
            start of the Shift using the cancellation function on the Locumate Platform or by emailing <a href="mailto:support@locumate.com.au">support@locumate.com.au.</a>
           </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">6</span> restraint</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">6.1 </span> If Locumate introduces you to a Locum, you must use the Locumate
            Platform to continue receiving Pharmacy
            Services from that Locum. You must not at any time persuade or attempt to persuade any Locum you are
            introduced to through the Locumate Platform to cease using the Locumate Platform and provide services directly
            to you outside the Locumate Platform.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">6.2 </span> We may suspend your account if we reasonably believe you have not
            complied with this restraint.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">6.3 </span> If you fail to comply with clause 6.1,we may charge you a fee of $50
            for each Shift a Locum works for you that
            is not arranged through the Locumate Platform. You agree that the amount of this fee constitutes a reasonable
            and good faith pre-estimate of loss that we will suffer and is not a penalty.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">6.4 </span> If you employ a Locum at any time after the Locum has provided Pharmacy Services to you using the Locumate Platform, you must pay us a referral fee equal to 10% of the Locum’s total remuneration package (including wages, benefits, bonuses and superannuation contributions) in the first year of employment. You must promptly notify us if you employ such a Locum and provide details of the Locum’s total remuneration package.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">7</span> FEES and other charges
          </h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">7.1 </span> <b>Pharmacy Charges
          </b> </div><br/>
          <div class="tertiary_align">
            <span class="tertiary_point">7.1.1</span><div class="tertiary_content">The Pharmacy Services Fees for Pharmacy Services will be charged at
            the hourly rate(s) you specify on the
            Locumate Platform in respect of the request for the Pharmacy Services.</div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.2</span><div class="tertiary_content"> The Pharmacy Services Fees are inclusive of superannuation contributions sufficient for you to avoid a charge under the <i>Superannuation Guarantee Charge Act 1992 </i>(Cth). You must make superannuation contributions to the complying superannuation fund of the Locum’s choice as nominated by the Locum through the Locumate Platform. If the Locum does not nominate a superannuation fund, you must make superannuation contributions to a superannuation fund of your choice.
            </div></div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.3</span><div class="tertiary_content"> Travel Expense Reimbursement Amounts will be paid in accordance with
            the Standard Terms of Engagement.
            </div></div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.4</span><div class="tertiary_content">Locumate will issue the Pharmacy an RCTI each Monday for each Shift
            or part of a Shift completed in the
            previous week.
            </div></div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.5</span><div class="tertiary_content">We will prepare RCTIs based on the time recorded by Locums and
            entered on the Locumate Platform. You will have
            the opportunity to check these time entries on a real time basis. If you do not dispute a time entry within 24
            hours of it being entered, then the entry will be deemed to be correct and you must not dispute it.
           </div></div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.6</span><div class="tertiary_content">The Pharmacy acknowledges that the Locum has appointed Locumate as the Locum’s sole agent to collect Pharmacy Services Fees (less the superannuation contributions you must make directly) and Travel Expense Reimbursement Amounts.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">7.2 </span> <b>Locumate Services Fees </b> </div><br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.1</span> <div class="tertiary_content">The Pharmacy agrees to pay the Locumate Services Fee to Locumate in
            consideration for the provision of the
            Locumate Services.</div></div>
            <br/>
            <div class="tertiary_align">
              <span class="tertiary_point">7.2.2</span><div class="tertiary_content"> We may adjust the Locumate Services Fee from time to time by given
            you at least one month’s notice.
          </div>
            </div>
            <br/>
            <div class="tertiary_align">
              <span class="tertiary_point">7.2.3</span><div class="tertiary_content"> The Pharmacy agrees to pay Locumate the PayNow Fee in consideration of the provision of the PayNow Service.
          </div>
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">7.3 </span> <b>Payments </b> </div><br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.3.1</span> <div class="tertiary_content">The Pharmacy is required to pay the Charges within 7 days of receipt
            of a valid tax invoice or RCTI (as the
            case may be) provided by Locumate.
          </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.3.2</span> <div class="tertiary_content">Locumate may suspend performance of the Locumate Services at any
            time if any Charges remain unpaid for more
            than 7 days after the due date.
      </div></div>
            <br/>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">7.4 </span> <b>GST </b></div> <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.1</span> <div class="tertiary_content">Unless the context indicates otherwise, any term or expression in
            this clause 6.4 that is defined or used in
            the GST Act has the meaning given to it in the GST Act.
      </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.2</span><div class="tertiary_content"> The Charges for any supply made under or in connection with these
            Terms of Access are exclusive of GST.
            </div>
            </div>
      
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.3</span> <div class="tertiary_content">If:</div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span> <div class="tertiary_content">a party makes a supply under on in connection with these Terms of
            Access that is subject to GST; and
            </div>
            </div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span> <div class="tertiary_content">the consideration for such a supply is not expressed to be GST
            inclusive,
      
            <br/>
            then in addition to the consideration otherwise to be paid or provided for that supply but for the application
            of this clause 6.4.2, the recipient of that supply shall, subject to receipt of a tax invoice or RCTI by the
            relevant party, pay an amount equal to the GST payable.
          </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.4</span> <div class="tertiary_content">You authorise Locumate to issue RCTIs on your behalf in respect of
            the Pharmacy Services suppled to you.
            </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.5</span><div class="tertiary_content"> The Pharmacy warrants that it is registered or will be registered for
            GST and has an Australian Business
            Number at each time a taxable supply is made.
            </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.4.6</span><div class="tertiary_content"> The Pharmacy must pay any other applicable charges, taxes and duties
            in addition to the Charges.
            </div></div>
            <br/>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">8</span> Access to LOCUMATE SERVICES</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">8.1 </span> You acknowledge and agree that:
          </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.1</span><div class="tertiary_content"> Locumate Services may not function as intended (or at all) if you do
            not have hardware, software or internet
            access which is compatible with Locumate Services;
            </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.2</span> <div class="tertiary_content">any timeframes we provide to you relation to Locumate Services are
            estimates only;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.3</span> <div class="tertiary_content">Locumate Services may not be available from time to time and we make
            no guarantee that Locumate Services will
            be available 24/7;
          </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.4</span> <div class="tertiary_content">where Locumate Services are to be subject to scheduled maintenance,
            we will use our reasonable endeavours to
            notify you; and
              </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.5</span> <div class="tertiary_content">we make no representation and give no warranty that the Locumate
            Services will be free from errors and
            defects.</div></div>
            <br/>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">9</span> Intellectual Property</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">9.1 </span> You acknowledge and agree that:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">9.1.1</span> <div class="tertiary_content">all right, title and interest in and to the Locumate Services
            (including all Intellectual Property Rights)
            vest in and belong to us;
            </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">9.1.2</span> <div class="tertiary_content">the rights in Locumate Services are licensed to you on a personal,
            revocable, non-exclusive and non-commercial
            basis as set out in these Terms of Access; and
          </div>
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">9.1.3</span> <div class="tertiary_content">nothing in these Terms of Access should be construed as constituting
            an assignment of the Intellectual
            Property Rights or other rights in Locumate Services to you.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">10</span> CONFIDENTIALITY AND PRIVACY</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">10.1 </span> Any information you disclose to us or our contractors as part of
            the Services will be kept confidential by us,
            our contractors, employees and agents. We will not disclose such information without your prior written
            consent or if required to disclose the information by law, for example, to a court in response to a subpoena.
            </div>
            <br/>
      
            <div class="secondary_align">
            <span class="secondary_point">10.2 </span> If any personal or health information is disclosed to us, we will
            treat that information in accordance with
            the Privacy Laws and any applicable health records legislation.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">11</span> RECORDS</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">11.1 </span> All records created by us or our staff as part of the Locumate
            Services belong to us and remain our property.
            Our records will only relate to administrative matters such as personal contact details, Pharmacy Services
            request details and payment.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.2 </span> Your Locum is responsible for keeping all medical and health
            records created in connection with the Pharmacy
            Services.
          </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">12</span> insurance</h3>
          <div>
            You are responsible for ensuring the Pharmacy has and maintains all appropriate insurance required to enable
            the Locum to provide the Pharmacy Services, including without limitation, public liability insurance and
            workers’ compensation insurance as required by law.
            <br/>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">13</span> COMPLAINTS</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">13.1 </span> If you have any concerns and wish to make a complaint regarding the
            Pharmacy Services you must make the
            complaint directly to your Locum or AHPRA. Locumate is not responsible for handling any complaints you may
            have regarding the provision of the Pharmacy Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">13.2 </span> If you have any concerns regarding the Locumate Services, please
            direct them to Locumate at
            <a href="mailto:suppport@locumate.com.au">
              suppport@locumate.com.au.</a
            >
           </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">13.3 </span> You must indemnify us against all Loss which Locumate suffers or
            incurs as a result of or in connection with
            any claims arising out of or in connection with the Pharmacy Services (including any complaints made under
            this clause) or the provision of the Pharmacy Services by the Locum.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">14</span> Warranties and liability</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">14.1 </span> To the extent permitted by law, you acknowledge and agree that we
            do not make any warranties, representations
            or guarantees as to:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.1.1</span>  <div class="tertiary_content">the suitability, skills and qualifications of a Locum who accepts
            your request for Pharmacy Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.1.2</span> <div class="tertiary_content">the access to or use of Locumate Services being uninterrupted,
            timely, secure, error-free or continuing for
            any period of time;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.1.3</span> <div class="tertiary_content">the availability of access to or use of Locumate Services in
            respect of specific geographical areas;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.1.4</span> <div class="tertiary_content">the ability of Locumate Services to operate with any other
            hardware, software, system or data, and all other terms, conditions and warranties, whether express or
            implied by legislation or the common law or
            otherwise relating to the provision by us of the Locumate Services or otherwise in connection with these Terms
            of Access are, to the maximum extent permitted by law, expressly excluded.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">14.2 </span> We will not be liable for any Loss (including indirectly or
            consequential loss) however caused which may be
            suffered or incurred or which may arise directly or indirectly in respect of the use of Locumate Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">14.3 </span> To the extent that we cannot lawfully exclude our liability to you,
            then to the maximum extent permitted by
            Law, we limit our liability to you to the cost of resupplying the services to you as contemplated under these
            Terms of Access.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">14.4 </span> Nothing in these Terms of Access excludes, restricts or modifies
            any rights that you may have under existing
            laws, including <i style="display: contents;">the Competition and Consumer Act 2010 (Cth)</i>.
              </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">15</span> Account suspension or termination</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">15.1 </span> You acknowledge and agree that we may monitor your account and
            activity on the Locumate Platform from time to
            time.
              </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.2 </span> We may at any time suspend or terminate your access to Locumate
            Services, including if any of the following
            occurs:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.1</span><div class="tertiary_content"> we detect any suspicious activity occurring in relation to your
            account, including creating false accounts
            with the intention of determining the price of Pharmacy Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.2</span><div class="tertiary_content"> for any reason, as long as we give you at least 30 days’ notice;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.3</span><div class="tertiary_content">you default in payment of any Charges when they fall due;
              </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.4</span> <div class="tertiary_content"> you breach these Terms of Access;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.5</span> <div class="tertiary_content">the information you have provided to us is inaccurate, incomplete or
            outdated and you do not immediately take
            steps to correct the information;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.6</span><div class="tertiary_content"> we are required to do so to comply with a law, order or
            instruction;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.7</span><div class="tertiary_content"> if we determine that it is not technically or operationally
            feasible or commercially viable to continue
            providing you access to Locumate Services; or
          </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.2.8</span><div class="tertiary_content"> we are required to disable access to Locumate Services for the
            purpose of carrying out support and/or
            maintenance.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.3 </span> If your account is suspended or terminated, you remain liable to
            pay any outstanding Charges including any
            Charges payable for Shifts that have not been completed at the time your account is suspended or terminated.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">16</span> general</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">16.1 </span> These Terms of Access constitute the entire agreement with respect
            to your access to and use of Locumate
            Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.2 </span> We may update these terms and conditions at any time. We will
            provide you with 14 days’ notice of any change
            to these conditions. If you have any concerns or do not agree to the changes to the terms, please notify us as
            soon as possible.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.3 </span> If any information given to you by our personnel is inconsistent
            with these Terms of Access, these Terms of
            Access prevail.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.4 </span> We may send you notices electronically by email to the email
            address listed as you provided when you created
            your account. You must notify us promptly of any change to your email address.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.5 </span> We will try to resolve any disagreements quickly and efficiently.
            If you are not satisfied with the way we
            deal with any disagreement and you want to start court proceedings, the laws of the State of Victoria,
            Australia apply to these Terms of Access and you may only pursue a legal action or proceeding in relation to
            Locumate Services in Victoria, Australia.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.6 </span>The rights conferred on you under these Terms of Access are personal
            to you and cannot be assigned or novated
            to another party except with our prior written consent.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.7 </span> Clauses 9 (Intellectual Property), 10 (Confidentiality and
            Privacy), 14 (Warranties and Liability) and this
            clause 16.7 (General) and any associated definitions survive the termination or expiry of these Terms of
            Access.
            </div>
            <br/>
          </div>
          <h3 class="title"><span class="main_point">17</span> Definitions</h3>
          <p>
      
            <span class="secondary_point">17.1 </span> In these Terms of Access:
      
          </p>
          <ul class="no_markers">
            <li>
              <b>Approvals </b> includes certifications, licenses, qualifications and registrations.
            </li>
            <br/>
            <li>
              <b>Charges </b> means all fees and other amounts payable by the Pharmacy in accordance with these Terms of
              Access and includes the Locumate Services Fee, the PayNow Fee, the Pharmacy Services Fee and Travel Expense Reimbursement
              Amounts.
            </li>
            <br/>
            <li>
              <b>Engagement </b> means the engagement by you of the Locum to provide Pharmacy Services in accordance with
              the contract that is created between you and a Locum pursuant to clause 4.5.
            </li>
            <br/>
            <li>
              <b>GST </b> Act means the <i>A New System (Goods and Services Tax) Act 1999 </i>(Cth).
            </li>
            <br/>
            <li>
              <b>Intellectual Property Rights </b>means any copyright, trademark (whether registered or unregistered),
              design, patent, semiconductor or circuit layout rights, trade, business or company names, other proprietary
              rights and rights to the registration of any of the foregoing existing anywhere in the world and existing
              before, on or after the commencement of these Terms of Access;
            </li>
            <br/>
            <li>
              <b>Locum </b> means a Locum the Pharmacy is connected to through the Locumate Platform who is available to
              provide the Pharmacy Services to the Pharmacy and meets the Pharmacy’s criteria for those services.
            </li>
            <br/>
            <li>
              <b>Locumate, us or we </b> means Locumate Australia Pty Ltd ABN 79 649 537 155.
            </li>
            <br/>
            <li>
              <b>Locumate Platform </b> means the online platform and mobile application owned and operated by Locumate.
            </li>
            <br/>
            <li>
              <b>Locumate Services </b>means the services we provide to Pharmacies under these Terms of Access by means of
              the Locumate Platform.
            </li>
            <br/>
            <li>
              <b>Locumate Services Fee </b> means the fee payable by the Pharmacy to Locumate in consideration for the
              provision of the Locumate Services, being the fee per Shift specified on the following page of this website:
              <a href="https://locumate.com.au/application-service-fee/">Click here to access</a>, as varied from time to time.
            </li>
            <br/>
            <li>
              <b>Locumate Website </b> means our website at
              <a href="https:\www.locumate.com.au">www.locumate.com.au.</a>
            </li>
            <br/>
            <li><b>Loss </b> means loss, liability, damage, cost and expense.</li>
            <br/>
            <li><b>PayNow Fee </b> means the fee payable by the Pharmacy to Locumate for each payment of a Pharmacy Services Fee or Travel Expense Reimbursement Amount to a Locum engaged by the Pharmacy using the PayNow Service, being an amount equal to 3% of the Pharmacy Services Fee or Travel Expense Reimbursement Amount.</li>
            <br/>
            <li><b>PayNow Service </b> means the financial solution made available on the Locumate Platform that enables Locums to receive payment of a Pharmacy Services Fee and a Travel Expense Reimbursement Amount on the next day.</li>
            <br/>
            <li>
              <b>Pharmacy </b>means a pharmacy registered with the Locumate Platform which are able to make a request to
              receive Pharmacy Services in accordance with these Terms of Access, and includes a pharmacy business, a
              pharmacy department and a pharmacy depot.
            </li>
            <br/>
            <li>
              <b>Pharmacy Services </b>means the pharmacy services provided directly to the Pharmacy by a Locum connected
              to the Pharmacy through the Locumate Platform.
            </li>
            <br/>
            <li>
              <b>Pharmacy Services Fee </b>means the fee payable by the Pharmacy to the Locum for the provision of the
              Pharmacy Services.
            </li>
            <br/>
            <li>
              <b>Privacy Laws </b>means <i>the Privacy Act 1988 </i>(Cth) and the Australian Privacy Principles (as defined in
              that Act).
            </li>
            <br/>
            <li>
              <b>RCTI </b>means a recipient-created tax invoice as defined by the GST Act.
            </li>
            <br/>
            <li>
              <b>Standard Terms of Engagement </b>the ‘Terms of Engagement (Standard Terms) between the Locum and the
              Pharmacy’ that can be found at the following link: <a href="https://locumate.com.au/wp-content/uploads/2023/01/Locumate-Locum-Terms-of-Access-and-Terms-of-Engagement-Jan2023.pdf">Click here to access.</a>
            </li>
            <br/>
            <li>
              <b>Terms of Access </b>means these terms of access as varied from time to time.
            </li>
            <br/>
            <li>
              <b>Travel Expense Reimbursement Amount </b>has the meaning given in the Standard Terms of Engagement.
            </li>
            <br/>
            <li>
              <b>User ID </b>means your email address or other details which you use to access Locumate Services.
            </li>
          </ul>
        </div>
      </div>
      <div v-if="userRole === 'locum' || routeName === 'terms_and_conditions2' || routeName === 'terms_and_conditions_guest_shift'">
        <div class="page_title">
          LOCUM TERMS OF ACCESS
        </div>
        <div>
          Last updated: June 01, 2023
          <br/>
          <br/>
          Please read these terms and conditions carefully before using Our
          Service.
          <br/>
          <br/>
          These terms apply to all Locumate Services you access through the
          Locumate Platform. <br/>
          <br/>
          We operate an online system which connects Pharmacies to Locums looking
          for work. <br/>
          <br/>
          These Terms of Access constitute an agreement between us and you. By registering with Locumate and continuing to
          use the Locumate Platform, you are deemed to have read, understood and accepted these Terms of Access.
          <br/>
          <br/>
          We reserve the right to amend these Terms of Access from time to time. We will use our reasonable endeavours to
          draw your attention to such amendments (for example, by email or placing a notice on our website), however it
          remains your responsibility to periodically review these Terms of Access. You acknowledge and agree that your
          continued use of Locumate Services after any changes to these Terms of Access will be deemed by us to be your
          acceptance of any amendments.
          <br>
          Any questions about these Terms of Access or requests for technical assistance may be sent
          <a href="mailto:support@locumate.com.au">support@locumate.com.au.</a>
          Alternatively, call us on <a href="tel: 0391207780">03 9120 7780.</a>
          <br/>
          <br/>
          <h4 class="title">AGREEMENT TERMS</h4>
          <br/>
          <h3 class="title uppercase"><span class="main_point">1</span> locumate platform account</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">1.1 </span> To access the Locumate Services, you must create an account with us
            by:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.1.1</span><div class="tertiary_content"> providing the information requested by us; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.1.2</span><div class="tertiary_content"> creating a password that meets our minimum requirements.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">1.2 </span> You acknowledge and agree that:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.1</span><div class="tertiary_content"> you are responsible for ensuring all information you provide us is
            correct and up to date;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.2</span><div class="tertiary_content"> you are responsible for the activity that occurs on your account;
          </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.3</span> <div class="tertiary_content">you must take all necessary steps to protect your User ID, password
            and account from unauthorised access; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.4</span> <div class="tertiary_content"> you will immediately notify us if:
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span><div class="tertiary_content"> the information you have provided is incorrect, inaccurate or
            incomplete; or
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span><div class="tertiary_content"> you become aware of or suspect that your User ID, password or account
            is being used or may have been accessed
            without your consent;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.5</span><div class="tertiary_content"> you must not use the Locumate Platform for an illegal purpose or in
            a manner that is inconsistent with these
            Terms of Access; and
        </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">1.2.6</span><div class="tertiary_content"> you must not supply or upload any content that: (i) would cause you
            or Locumate to breach any law, regulation
            or code of conduct; (ii) is or could reasonably considered to be obscene, inappropriate, defamatory,
            disparaging, indecent, seditious, offensive, pornographic, threatening, abusive, liable to incite racial
            hatred, discriminatory, blasphemous, in breach of confidence or in breach of privacy; or (iii) that could
            infringe any person’s rights, including their intellectual property.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">2</span> locumate SERVICES</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">2.1 </span> If you create an account with us, we will provide Locumate Services
            to you. These are technology,
            communication and administration services to enable you to use the Locumate Platform to be connected with
            Pharmacists based on the Locum’s needs.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.2 </span> The Locum will also have a separate relationship with any Pharmacy
            with whom the Locum is placed. The Locum is
            responsible for providing the Pharmacy Services to the Pharmacy directly in accordance with the Standard Terms
            of Engagement.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.3 </span> Locumate does not provide Pharmacy Services, employ or engage Locums
            or supply Locums to Pharmacies. Locums do
            not work for Locumate. All Locums who use the Locumate Platform practise independently.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">2.4 </span> Locumate Services include but are not limited to:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">2.4.1</span><div class="tertiary_content"> A website and mobile application which provides a platform that
            performs functions such as:
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span><div class="tertiary_content"> allowing you to create an account on the Locumate Platform;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span><div class="tertiary_content"> enabling Pharmacies to lodge a request for Pharmacy Services required
            by them, including specifying the
            details of the location, dates and times the Pharmacy Services are required and associated fees;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(c)</span><div class="tertiary_content"> matching Pharmacies with Locums who respond to a request for Pharmacy
            Services which meet the criteria of the
            Pharmacy;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(d)</span> <div class="tertiary_content"> paying the Locum for Pharmacy Services on behalf of the Pharmacy;
           </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(e)</span><div class="tertiary_content"> paying Locumate for Locumate Services; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">2.4.2</span><div class="tertiary_content"> technical support services.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">3</span> your responsibilities</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">3.1 </span> To use the Locumate Platform, you warrant that you:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.1</span><div class="tertiary_content"> are 18 years or over;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.2</span><div class="tertiary_content"> will ensure that you maintain, without any suspension, restriction
            or limitation, all Approvals necessary to
            provide Pharmacy Services in accordance with all applicable laws; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.3</span><div class="tertiary_content"> will provide us with copies of all Approvals referred to in clause
            3.1.3 upon request.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">3.2 </span> You must immediately notify us of any changes to your Approvals or
            if any condition or other restriction is
            imposed on you which restricts your ability to provide Pharmacy Services. You acknowledge that we may
            immediately suspend your account and refuse you access to Locumate Services as a result of any changes to your
            Approvals.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">4</span> PLACEMENTS</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">4.1 </span> You may use the Locumate Platform to accept requests for Pharmacy
            Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.2 </span> The Locum who meets the Pharmacy’s criteria and first accepts a
            Pharmacy’s request for Pharmacy Services will
            be placed with the Pharmacy. If you are placed with the Pharmacy, we will provide you with their details to
            enable you to connect to the Pharmacy. We will also notify the Pharmacy that you have been placed with them.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.3 </span> You will provide the Pharmacy Services to the Pharmacy directly. If
            you are placed with a Pharmacy, a binding
            contract will be formed between you and the Pharmacy on the Standard Terms of Engagement at the time we notify
            the Pharmacy of your placement. You are free to negotiate with the Pharmacy changes to the Standard Terms of
            Engagement. You acknowledge that:
           </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.3.1</span><div class="tertiary_content"> Locumate is not a party to any contract between the Locum and
            Pharmacy; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">4.3.2</span><div class="tertiary_content"> Locumate does not provide tax, contract, commercial or employment
            advice as to the engagement of Locums by
            Pharmacies or warrant or represent that the Standard Terms of Engagement are suitable for your purposes.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.4 </span> It is a condition of using the Locumate Platform that you have
            specialist registration as a pharmacist with
            the Pharmacy Board of Australia and the Australian Health Practitioner Regulation Agency (AHPRA).
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.5 </span>You must immediately notify us in writing if you become aware of any
            event or circumstance in relation to the
            Pharmacy at which you are placed or Pharmacy Services you supply which could reasonably be expected to
            directly or indirectly harm or diminish confidence in and/or the standing or reputation of Locumate, the
            Locum, the Pharmacy or the Pharmacy Services.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">5</span> cancellation</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">5.1 </span>You may cancel an Engagement by giving the Pharmacy not less than 72
            hours’ notice of cancellation before the
            start of the Shift using the cancellation function on the Locumate Platform or emailing <a href="mailto:suppport@locumate.com.au">
              suppport@locumate.com.au.</a
            >
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">5.2 </span> The Pharmacy may cancel an Engagement by giving you not less than 72
            hours’ notice of cancellation before the
            start of the Shift using the cancellation function on the Locumate Platform.
           </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">6</span> restraint</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">6.1 </span> If Locumate introduces you to a Pharmacy, you must use the Locumate
            Platform to continue providing Pharmacy
            Services to that Pharmacy. You must not at any time persuade or attempt to persuade any Pharmacy you are
            introduced to through the Locumate Platform to cease using the Locumate Platform and acquire services directly
            from you outside the Locumate Platform.
           </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">6.2 </span> We may suspend or terminate your account if we reasonably believe
            you have not complied with this restraint.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">6.3 </span> If you fail to comply with clause 6.1, we may charge you a fee of
            $50 for each Shift you work for a Pharmacy
            that is not arranged through the Locumate Platform. You agree that the amount of this fee constitutes a
            reasonable and good faith pre-estimate of loss that we will suffer, having regard to the fact, among other
            things, that we may not be paid a fee by the Pharmacy for the Shift you work. You agree that this fee is not a
            penalty.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">7</span> FEES AND other charges
          </h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">7.1</span> <b>Pharmacy Charges </b>   </div><br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.1</span><div class="tertiary_content"> The Pharmacy Services Fees for Pharmacy Services will be specified
            on the Locumate Platform in the request for
            the Pharmacy Services.
              </div></div>
      
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.2</span><div class="tertiary_content"> The Pharmacy Services Fees are inclusive of superannuation contributions sufficient for the Pharmacy to avoid a charge under the <i>Superannuation Guarantee Charge Act 1992 </i>(Cth). The Pharmacy will make superannuation contributions to the complying superannuation fund of your choice as nominated by you through the Locumate Platform. If you do not nominate a superannuation fund, the Pharmacy will make superannuation contributions to a superannuation fund of its choice,
           </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.3</span> <div class="tertiary_content">We will issue RCTIs (recipient created tax invoice) on behalf of the
            Pharmacy in respect of the Pharmacy
            Services you supply. You do not need to (and must not) issue a tax invoice to the Pharmacy for a Shift. The
            Pharmacy must pay each RCTI to Locumate in accordance with the Pharmacy Terms of Access.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.4</span><div class="tertiary_content"> We will issue an RCTI each Monday for each Shift or part of a Shift
            completed in the previous week.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.5</span><div class="tertiary_content"> Locumate will pay invoiced Pharmacy Charges due to you within 48
            hours after the day of receipt by us of those
            Pharmacy Charges.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.6</span><div class="tertiary_content"> You appoint Locumate as your agent to collect Pharmacy Charges (less the superannuation contributions the Pharmacy must make) on
            your behalf. Locumate will collect Pharmacy
            Charges (less the superannuation contributions the Pharmacies must make) from the Pharmacies who engage you.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.7</span><div class="tertiary_content"> If a dispute arises out of or relates to the Pharmacy Charges paid
            by the Pharmacy who engaged you to us or
            paid by us to you, you must take up the dispute with the Pharmacy. Locumate will not take participate in any
            dispute in the absence of manifest error by Locumate. You must indemnify us from and against any Loss we may
            suffer or incur if you involve us in any such dispute.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">7.2</span> <b>Payment and invoicing </b> </div><br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.1</span><div class="tertiary_content"> You are required to pay the Fees within 7 days of receipt of a valid
            tax invoice provided by Locumate.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.2</span><div class="tertiary_content"> We may deduct any Fees which you owe us from the Pharmacy Charges
            which we owe you.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.3</span><div class="tertiary_content"> Locumate may suspend performance of the Locumate Services at any
            time if the Fees remain unpaid for more than
            7 days after the due date.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.4</span><div class="tertiary_content"> Unless otherwise stated, the Fees are expressed as a GST exclusive
            amount.
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.5</span><div class="tertiary_content"> The Locum warrants that it is registered or will be registered for
            GST and has an Australian Business Number
            at each time a taxable supply is made.
           </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.2.6</span><div class="tertiary_content"> The Locum must pay any other applicable charges, taxes and duties in
            addition to the Fees.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">8</span> Access to LOCUMATE SERVICES</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">8.1.1 </span> You acknowledge and agree that:</div><br/>
      
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span><div class="tertiary_content"> Locumate Services may not function as intended (or at all) if you do
            not have hardware, software or internet
            access which is compatible with Locumate Services;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span><div class="tertiary_content"> any timeframes we provide to you relation to Locumate Services are
            estimates only;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(c)</span><div class="tertiary_content">Locumate Services may not be available from time to time and we make no
            guarantee that Locumate Services will
            be available 24/7;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(d)</span> <div class="tertiary_content">where Locumate Services are to be subject to scheduled maintenance, we
            will use our reasonable endeavours to
            notify you; and
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(e)</span><div class="tertiary_content"> we make no representation and give no warranty that the Locumate
            Services will be free from errors and
            defects.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">9</span> Intellectual Property</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">9.1 </span> You acknowledge and agree that:</div><br/>
      
            <span class="tertiary_point">9.1.1</span> all right, title and interest in and to the Locumate Services
            (including all Intellectual Property Rights)
            vest in and belong to us;
            <br/>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">9.1.2</span><div class="tertiary_content"> the rights in Locumate Services are licensed to you on a personal,
            revocable, non-exclusive and non-commercial
            basis as set out in these Terms of Access; and
           </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">9.1.3</span><div class="tertiary_content"> nothing in these Terms of Access should be construed as constituting
            an assignment of the Intellectual
            Property Rights or other rights in Locumate Services to you.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">10</span> CONFIDENTIALITY AND PRIVACY</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">10.1 </span> Any information you disclose to us or our contractors in the course
            of using the Locumate Services will be
            kept confidential by us, our contractors, employees and agents. We will not disclose such information without
            your prior written consent or if required to disclose the information by law, for example, to a court in
            response to a subpoena.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.2 </span>If any personal or health information is disclosed to us, we will
            treat that information in accordance with
            the Privacy Laws and any applicable health records legislation.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.3 </span> The Pharmacy is responsible for keeping all medical and health
            records created in connection with the Pharmacy
            Services.
           </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">11</span> RECORDS</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">11.1</span> All records created by us or our staff as part of the Locumate
            Services belong to us and remain our property.
            Our records will only relate to administrative matters such as personal contact details, Pharmacy Services
            request details and payment.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.2</span> You are responsible for keeping all medical and health records
            created in connection with the Pharmacy
            Services.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">12</span> COMPLAINTS</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">12.1</span> If you have any concerns and wish to make a complaint regarding the
            Pharmacy Services you must make the
            complaint directly to your Pharmacy or AHPRA. Locumate is not responsible for handling any complaints you may
            have regarding the provision of the Pharmacy Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">12.2 </span> If you have any concerns regarding the Locumate Services, please
            direct them to Locumate at
            <a href="mailto:suppport@locumate.com.au">
              suppport@locumate.com.au.</a
            >
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">12.3 </span> You must indemnify us against all Loss which Locumate suffers or
            incurs as a result of or in connection with
            any claims arising out of or in connection with the Pharmacy Services (including any complaints made under
            this clause) or the provision of the Pharmacy Services by you.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">13</span> Warranties and liability</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">13.1 </span> To the extent permitted by law, you acknowledge and agree that we
            do not make any warranties, representations
            or guarantees as to:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">13.1.1</span><div class="tertiary_content"> the access to or use of Locumate Services being uninterrupted,
            timely, secure, error-free or continuing for
            any period of time;
           </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">13.1.2</span><div class="tertiary_content"> the availability of access to or use of Locumate Services in
            respect of specific geographical areas;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">13.1.3</span><div class="tertiary_content"> the ability of Locumate Services to operate with any other
            hardware, software, system or data, and all other terms, conditions and warranties, whether express or implied by legislation or the common law or
            otherwise relating to the provision by us of the Locumate Services or otherwise in connection with these Terms
            of Access are, to the maximum extent permitted by law, expressly excluded.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">13.2 </span> We will not be liable for any Loss (including indirectly or
            consequential loss) however caused which may be
            suffered or incurred or which may arise directly or indirectly in respect of the use of Locumate Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">13.3 </span> To the extent that we cannot lawfully exclude our liability to you,
            then to the maximum extent permitted by
            Law, we limit our liability to you to the cost of resupplying the services to you as contemplated under these
            Terms of Access.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">13.4 </span> Nothing in these Terms of Access excludes, restricts or modifies
            any rights that you may have under existing
            laws, including <i style="display: contents;">the Competition and Consumer Act 2010 (Cth)</i>.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">14</span> Account suspension or termination</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">14.1</span> You acknowledge and agree that we may monitor your account and
            activity on the Locumate Platform from time to
            time.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">14.2 </span> We may at any time suspend or terminate your access to Locumate
            Services, including if any of the following
            occurs:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.1</span><div class="tertiary_content"> we detect any suspicious activity occurring in relation to your
            account, including creating false accounts
            with the intention of determining the price of Pharmacy Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.2</span><div class="tertiary_content"> you default in payment of any Fees when they fall due;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.3</span><div class="tertiary_content"> you breach these Terms of Access;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.4</span><div class="tertiary_content"> the information you have provided to us is inaccurate, incomplete
            or outdated and you do not immediately take
            steps to correct the information;
           </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.5</span><div class="tertiary_content"> we are required to do so to comply with a law, order or
            instruction;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.6</span><div class="tertiary_content"> if we determine that it is not technically or operationally
            feasible or commercially viable to continue
            providing you access to Locumate Services; or
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.7</span><div class="tertiary_content"> we are required to disable access to Locumate Services for the
            purpose of carrying out support and/or
            maintenance;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">14.2.8</span><div class="tertiary_content"> you have done anything, or are likely to do anything, that may
            damage the reputation of Locumate or any
            Pharmacy.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">14.3 </span> We may suspend or terminate your access to the Locumate Platform
            and/or all or any of the Locumate Services at
            any time for any reason for convenience..
           </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">15</span> general</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">15.1 </span> These Terms of Access constitute the entire agreement with respect
            to your access to and use of the Locumate
            Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.2 </span> We may update these Terms of Access at any time. We will provide
            you with 14 days’ notice of any change to
            these Terms of Access. If you have any concerns or do not agree to the changes to the terms, please notify us
            as soon as possible.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.3 </span> If any information given to you by our personnel is inconsistent
            with these Terms of Access, these Terms of
            Access prevail.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.4 </span> We may send you notices electronically by email to the email
            address provided when you created your account or
            any change of email address you notify us. You must notify us promptly of any change to your email address.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.5 </span> We will try to resolve any disagreements quickly and efficiently.
            If you are not satisfied with the way we
            deal with any disagreement and you want to start court proceedings, the laws of the State of Victoria,
            Australia apply to these Terms of Access and you may only pursue a legal action or proceeding in relation to
            Locumate Services in Victoria, Australia.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.6 </span> The rights conferred on you under these Terms of Access are
            personal to you and cannot be assigned or novated
            to another party except with our prior written consent.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.7 </span> Clauses 8 (Intellectual Property), 9(Confidentiality and Privacy),
            12(Warranties and Liability) and this
            clause 14 (General) and any associated definitions survive the termination or expiry of these Terms of Access.
            </div>
            <br/>
          </div>
          <h3 class="title"><span class="main_point">16</span> Definitions</h3>
          <p>
      
            <span class="secondary_point">16.1 </span> In these Terms of Access:
      
          </p>
          <ul class="no_markers">
            <li>
              <b>Approvals </b> includes certifications, licenses, qualifications and registrations.
            </li>
            <br/>
            <li>
              <b>Engagement </b>means your engagement by the Pharmacy to provide Pharmacy Services in accordance with the
              contract that is created between you and a Pharmacy pursuant to clause 4.3.
            </li>
            <br/>
            <li>
              <b>Fees </b> means all fees payable by the Locum in accordance with these Terms of Access.
            </li>
            <br/>
            <li>
              <b>GST </b> means the goods and services tax levied under the <i> A New System (Goods and Services Tax) Act 1999</i>
              (Cth) as amended.
            </li>
            <br/>
            <li>
              <b>Intellectual Property Rights </b>means any copyright, trademark (whether registered or unregistered),
              design, patent, semiconductor or circuit layout rights, trade, business or company names, other proprietary
              rights and rights to the registration of any of the foregoing existing anywhere in the world and existing
              before, on or after the commencement of these Terms of Access;
            </li>
            <br/>
            <li>
              <b>Locum or you </b> means a locum pharmacist registered with the Locumate Platform who is available to
              provide Pharmacy Services to a Pharmacy in accordance with these Terms of Access.
            </li>
            <br/>
            <li>
              <b>Locumate, us or we </b> means Locumate Australia Pty Ltd ABN 79 649 537 155.
            </li>
            <br/>
            <li>
              <b>Locumate Platform </b> means the online platform and mobile application owned and operated by Locumate.
            </li>
            <br/>
            <li>
              <b>Locumate Services </b>means the services we supply to Locums under these Terms of Access by means of the
              Locumate Platform
            </li>
            <br/>
            <li>
              <b>Locumate Website </b> means our website at
              <a href="https:\www.locumate.com.au">www.locumate.com.au.</a>
            </li>
            <br/>
            <li><b>Loss </b>means loss, liability, damage, cost and expense.</li>
            <br/>
            <li>
              <b>Pharmacy </b>means a pharmacy registered with the Locumate Platform which is able to make a request to
              receive Pharmacy Services in accordance with the Pharmacy Terms of Access, and includes a pharmacy business,
              a pharmacy department and a pharmacy depot.
            </li>
            <br/>
            <li>
              <b>Pharmacy Charges </b>means the Pharmacy Services Fee and, if applicable, Travel Expense Reimbursement
              Amounts.
            </li>
            <br/>
            <li>
              <b>Pharmacy Services </b>means the pharmacy services provided directly by the Locum to a Pharmacy connected
              to the Locum through the Locumate Platform.
            </li>
            <br/>
            <li>
              <b>Pharmacy Services Fee </b>means the fee payable by the Pharmacy to the Locum for the provision of the
              Pharmacy Services.
            </li>
            <br/>
            <li>
              <b>Pharmacy Terms of Access </b>means the Pharmacy Terms of Access contained on the Locumate Website, as
              varied from time to time.
            </li>
            <br/>
            <li>
              <b>Privacy Laws </b>means the <i>Privacy Act 1988 </i>(Cth) and the Australian Privacy Principles (as defined in
              that Act).
            </li>
            <br/>
            <li>
              <b>Shift </b>means the duration of the Locum’s engagement as specified in a request for Services.
            </li>
            <br/>
            <li>
              <b>Standard Terms of Engagement </b>means the ‘Terms of Engagement (Standard Terms) between the Locum and
              the Pharmacy’ that can be found at the following link: [insert].
            </li>
            <br/>
            <li>
              <b>Terms of Access </b>means these terms of access as varied from time to time.
            </li>
            <br/>
            <li>
              <b>Travel Expense Reimbursement Amount </b>has the meaning given in the Standard Terms of Engagement.
            </li>
            <br/>
            <li>
              <b>User ID </b>means your email address or other details which you use to access Locumate Services.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div class="page_title">
          TERMS OF ENGAGEMENT (STANDARD TERMS) BETWEEN THE LOCUM AND PHARMACY
        </div>
        <div>
          These Terms of Engagement constitute an agreement between the Locum and the Pharmacy for the Engagement.
          <br/>
          <br/>
          By registering with Locumate, each of the Locum and the Pharmacy acknowledge to each other that they have read,
          understood and accepted these Terms of Engagement and have entered into a contract on these Terms of Engagement
          in respect of the Engagement.
          <br/>
          <br/>
          The Locum and the Pharmacy may amend these Terms of Engagement in respect of an Engagement by a document in
          writing.
          <br/>
          <br/>
          <br/>
          <h3 class="title uppercase">
            <span class="main_point">1 </span> Engagement of Locum
          </h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">1.1 </span> The Pharmacy engages the Locum to provide, and the Locum agrees to
            provide, the Services in accordance with
            the terms of this Contract for the Shift .
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">1.2 </span> The Services will be provided at the Premises unless otherwise
            agreed between the parties.</div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">1.3 </span> Nothing in this Contract will be deemed to create any partnership,
            franchise, agency, joint venture or
            relationship of employer and employee between the Pharmacy and the Locum.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">2</span> Responsibilities</h3>
      
          <div>
            <div class="secondary_align">
            <span class="secondary_point">2.1 </span> The Locum must carry out the Services in a conscientious,
            professional and expeditious manner, using all
            reasonable skill, care and diligence.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">3</span> Warranties</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">3.1 </span> The Locum warrants and undertakes he/she: </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.1</span><div class="tertiary_content"> possesses the skills and expertise to provide the Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.2</span><div class="tertiary_content"> is registered as a pharmacist with the Pharmacy Board of Australia
            and the Australian Health Practitioner
            Regulation Agency (“AHPRA”) and is qualified to perform all aspects of the Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.3</span><div class="tertiary_content"> is aware of the Pharmacy’s statutory and professional obligations as
            the proprietor of a pharmacy;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.4</span><div class="tertiary_content"> is eligible to work in Australia;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.5</span><div class="tertiary_content"> will abide by all Work Health & Safety obligations and take
            reasonable care for his/her safety and others;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.6</span><div class="tertiary_content"> will not attend the Premises under the influence of alcohol or drugs
            except for prescribed medication used in
            accordance with the prescription; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.7</span><div class="tertiary_content"> will maintain and bear the cost of all necessary licenses,
            registrations, qualifications, training
            requirements and insurance during the provision of the Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">3.1.8</span><div class="tertiary_content"> will accurately enter time spent working on a Shift in the Locumate
            Platform.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">4</span> Policies and laws</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">4.1 </span> The Locum agrees to comply with the Pharmacy’s policies and
            procedures, so far as they relate to the Locum,
            including the policies and procedures (if any) set out in the Request for Services. Such policies and
            procedures may be added to or amended, in writing, from time to time. It is agreed that such policies and
            procedures do not form part of this Contract.
           </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">4.2 </span> The Locum agrees to comply with all laws, codes, guidelines and
            policies that apply in connection with the
            Services and its registration as a pharmacist.
            </div>
      
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">5</span> Supervision</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">5.1 </span> The Locum must perform the Services without supervision by the
            Pharmacy and, subject to meeting any customer
            requirements and complying with any reasonable directions given by the Pharmacy, can set his/her own manner of
            performing the Services.
              </div>
      
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">6</span> No other duties</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">6.1 </span> The Locum will not be required by the Pharmacy to perform any duties
            in connection with the running or
            operation of the business of the Pharmacy or the Premises other than the provision of the Services.
             </div>
          </div>
          <h3 class="title uppercase"><span class="main_point">7</span> Other similar work</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">7.1 </span> The Locum can perform the same or similar work as the Services for
            other entities provided:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.1</span><div class="tertiary_content"> the Services under this Contract are performed to the satisfaction
            of the Pharmacy and its customers; and</div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">7.1.2</span><div class="tertiary_content"> performing the other work by the Locum does not otherwise breach any
            term of this Contract.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">8</span> Refusal to perform work</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">8.1 </span> The Locum may refuse to perform a particular assignment proposed by
            the Pharmacy provided:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.1</span><div class="tertiary_content"> the refusal is reasonable;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.2</span><div class="tertiary_content"> reasonable notice of the refusal is given; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">8.1.3</span><div class="tertiary_content"> the refusal does not affect the overall performance of the Services.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">9</span> No sub-contracting</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">9.1 </span> The Locum cannot sub-contract the Services to another pharmacist. If
            the Locum is unable to perform the
            Services for any reason, he/she must, as soon as reasonably practicable, notify both the Pharmacy and Locumate
            so that a suitable replacement can be found or other arrangement made.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">10</span> Fees and other charges
          </h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">10.1 </span>In consideration of the provision by the Locum of the Services, the Pharmacy agrees to pay the Locum the Fee.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.2 </span> The Fee is inclusive of superannuation contributions sufficient for the Pharmacy to avoid a charge under <i style="display: contents;">the Superannuation Guarantee Charge Act 1992(Cth)</i>. The Pharmacy will make superannuation contributions to the complying superannuation fund of the Locum’s choice as nominated by the Locum through the Locumate Platform. If the Locum does not nominate a superannuation fund, the Pharmacy will make superannuation contributions to a superannuation fund of its choice,
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.3 </span>If the Pharmacy has indicated in the Request for Services that it will pay the Locum the Travel Expense Reimbursement Amount, then the Pharmacy will pay the Locum the Travel Expense Reimbursement Amount.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.4 </span>The Travel Expense Reimbursement Amount is only payable if the distance travelled by the Locum from his or her principal place of residence to the Premises and back in a day (i.e. a round trip) (the Distanced Travelled) exceeds 50 kilometres. The Distance Travelled will be determined by Locumate using the Google Maps app or such other app as Locumate thinks fit. Locumate’s determination of the Distance Travelled is final and binding on the parties.  The Travel Expense Reimbursement Amount shall be calculated as a daily rate equal to the Distance Travelled (in kilometres) multiplied by ${{ travelCompensation }} or such other amount as Locumate may determine from time to time and publish on the Locumate Website.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.5 </span> The Locum directs the Pharmacy to pay the Charges (less the superannuation contributions the Pharmacy must make) to Locumate as the Locum’s agent in accordance with the Pharmacy Terms of Access. The Pharmacy agrees to pay the Charges (less the superannuation contributions the Pharmacy must make) to Locumate in accordance with the Pharmacy Terms of Access.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.6 </span> If the Pharmacy pays the Charges to Locumate in accordance with this Contract, it shall be discharged of any obligation to pay the Charges  to the Locum and shall not be responsible for any failure by Locumate to pay the Charges to the Locum.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.7 </span> The parties agree that the Fee is fair and reasonable and represents full and final payment regarding the Services to be provided including in respect of the value of any materials, superannuation and insurance costs of the Locum. The parties agree the Pharmacy may rely upon the Fee paid to offset any claim for underpayment made by the Locum.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">10.8 </span> The Pharmacy is not required to reimburse the Locum for any other costs and expenses unless they have been approved by the Pharmacy in advance in writing.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">11</span> GST</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">11.1 </span> Unless the context indicates otherwise, any term or expression in this clause 11 that is defined or used in
            the GST Act has the meaning given to it in the GST Act.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.2 </span> The Charges for any supply made under this Contract is exclusive of GST.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.3 </span> If:
            </div>
            <br/>
      
            <div class="tertiary_align">
            <span class="tertiary_point">11.3.1</span><div class="tertiary_content">  a party makes a supply under on in connection with this agreement that is subject to GST; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">11.3.2</span><div class="tertiary_content"> the consideration for such a supply is not expressed to be GST inclusive, then in addition to the consideration otherwise to be paid or provided for that supply but for the application
            of this clause 11.3, the recipient of that supply shall, subject to receipt of a tax invoice or RCTI by the
            relevant party, pay an amount equal to the GST payable.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.4 </span> Locumate will issue a RCTI (a recipient created tax invoice) in respect of the supply of the Services to the
            Pharmacy on behalf the Pharmacy, and the Pharmacy must pay each RCTI to Locumate in accordance with the
            Pharmacy Terms of Access.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.5 </span>  The Locum must not issue a tax invoice in respect of the supply of the Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.6 </span>  If Locumate does not issue a RCTI to the Locum in respect of Services supplied in a Billing Period within 14
            days after the end of a Billing Period, then the Locum may issue a tax invoice in respect of the supply of the
            Services.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.7 </span>  The Locum confirms that he/she is registered for GST and will notify the Pharmacy if he/she ceases to be
            registered.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.8 </span>  The Pharmacy confirms that it is registered for GST and will notify the Locum if it ceases to be registered or
            if it ceases to satisfy the Australian Taxation Office’s requirements for RCTIs.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">11.9 </span> Both parties acknowledge that they are parties to an RCTI agreement.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">12</span> other tax matters</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">12.1</span> Each party agrees to do all that is necessary to assist the other party in relation to providing documentation
            for taxation purposes.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">12.2</span> The Pharmacy is not responsible for any taxation liability regarding Services provided by the Locum under this
            Contract, including to PAYG tax, GST, Payroll Tax or any superannuation payment or obligation under <i style="display: contents;">the
            Superannuation Guarantee (Administration) Act 1992</i> (Cth).
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">13</span>  Benefits</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">13.1</span>  As an independent contractor the Locum is not entitled to any benefits, payments or allowances (including
            annual leave, personal leave, long service leave or any other leave to which the Locum might otherwise have
            been entitled if the Locum was an employee and not an independent contractor).
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">14</span> Equipment and facilities</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">14.1 </span> The Locum will provide his/her own protective clothing and any items of equipment considered by him/her to be
            necessary for the provision of the Services, which are not already available at the Premises.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">15</span> Indemnity and insurance</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">15.1 </span> The Locum indemnifies and must keep indemnified the Pharmacy and each other Indemnified Person from and
            against Loss incurred by the Pharmacy arising directly or indirectly as a result of or in connection with:
            </div>
            <br/>
          <div class="tertiary_align">
            <span class="tertiary_point">15.1.1</span><div class="tertiary_content"> the personal injury to or death of anyone and damage to any property caused by the Locum in providing the
            Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.1.2</span><div class="tertiary_content"> the acts, errors or omissions of the Locum in providing the Services; or
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">15.1.3</span><div class="tertiary_content"> the Pharmacy treating the relationship between it and the Locum as one of independent contractor.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.2 </span>The Locum must, at his/her cost, effect and maintain during the term of this Contract professional indemnity
            insurance that complies with the Pharmacy Board of Australia’s registration standard.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.3 </span> The Locum must
            provide to the Pharmacy evidence of this insurance on request.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">15.4 </span> The indemnity in this clause is held on bare trust by the Pharmacy for each other Indemnified Person (who may
            claim directly under it) and continues after the termination of this Contract.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">16</span> Termination</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">16.1 </span>   This Contract will terminate if the Locum or the Pharmacy cancels the Engagement in accordance with the terms
            of the Locum Terms of Access or the Pharmacy terms of Access.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.2</span>   Unless terminated earlier in accordance with clause 16.2, this Contract will automatically terminate at the
            end of the Shift,:
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.3</span>  This Contract may be terminated:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">16.3.1</span><div class="tertiary_content">  at any time for any reason by the Pharmacy or the Locum giving not less than 48 hours written prior notice to
            the other; or
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">16.3.2</span><div class="tertiary_content">
            by the Pharmacy without notice or any payment if the Locum:
          </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(a)</span><div class="tertiary_content"> is guilty of dishonesty or a criminal offence or is made bankrupt;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(b)</span><div class="tertiary_content"> is guilty of serious misconduct or serious neglect of duty in connection with the provision of the Services;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(c)</span><div class="tertiary_content">breaches this Contract and the breach is not capable of remedy;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(d)</span><div class="tertiary_content"> breaches this Contract and fails to rectify the breach within 2 days of being required to do so;
            </div></div>
            <br/>
            <div class="tertiary_align ml-4">
            <span class="tertiary_point">(e)</span><div class="tertiary_content"> engages in any act or omission that, in the reasonable opinion of the Pharmacy, has or will likely have the effect of causing material damage to the Pharmacy or its employees or the reputation of the Pharmacy.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">16.4</span>  Unless otherwise agreed, the Locum agrees, upon the termination of this Contract, to deliver up to the
            Pharmacy all property belonging to the Pharmacy which may be in his/her possession, including all Confidential
            Information, within 3 days of termination of this Contract.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">17</span> Confidential information</h3>
          <div>
        <div class="secondary_align">
            <span class="secondary_point">17.1 </span>  All Confidential Information is and remains the property of the Pharmacy.
            </div>
            <br/>
        <div class="secondary_align">
            <span class="secondary_point">17.2 </span> The Locum must not, at any time during or after the termination of this Contract, for any reason directly or
            indirectly disclose or use (or attempt to disclose or use) any Confidential Information for his/her own
            benefit or the benefit of any other person or entity.
            </div>
            <br/>
        <div class="secondary_align">
            <span class="secondary_point">17.3 </span>  The Locum may communicate Confidential Information only:
            </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">17.3.1</span><div class="tertiary_content"> in the proper performance of the Services;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">17.3.2</span><div class="tertiary_content"> if required to do so by the Pharmacy or by law;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">17.3.3</span><div class="tertiary_content"> to obtain legal or accounting advice relating to the Services or the terms of this Contract; or
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">17.3.4</span><div class="tertiary_content"> if the Locum obtains the Pharmacy’s prior written consent.
            </div></div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">17.4 </span>  The Locum must use his/her best endeavours to prevent the unauthorised use or disclosure of any Confidential
            Information by third parties.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">17.5 </span>  If there should be any uncertainty as to whether information is Confidential Information or is lawfully within
            the public domain, such information is taken to be Confidential Information and/or not permitted to be
            disclosed unless the Pharmacy advises the Locum in writing that the information is not Confidential
            Information and/or that it may be disclosed.
            </div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">18</span> Warranties</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">18.1 </span>  The Locum warrants that: </div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.1</span><div class="tertiary_content">  he/she has read and understood this Contract;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.2</span><div class="tertiary_content"> he/she has obtained, or had the opportunity to obtain, independent legal advice about this Contract;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.3</span><div class="tertiary_content"> he/she agrees that no promise, representation or inducement has been made by the Pharmacy, other than this
            Contract, for him/her to sign this Contract;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.4</span><div class="tertiary_content"> there are no restrictions which operate to prevent him/her performing the Services under this Contract;
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.5</span><div class="tertiary_content"> this Contract reflects the whole agreement between the parties concerning the Services and replaces any
            previous agreements, arrangements or understandings between the parties; and
            </div></div>
            <br/>
            <div class="tertiary_align">
            <span class="tertiary_point">18.1.6</span><div class="tertiary_content"> he/she is aware the Pharmacy is relying on these warranties.
            </div></div>
            <br/>
          </div>
          <h3 class="title uppercase"><span class="main_point">19</span> General</h3>
          <div>
            <div class="secondary_align">
            <span class="secondary_point">19.1 </span>  This Contract is governed by the laws of the State of Victoria. The parties submit to the non-exclusive
            jurisdiction of the courts of Victoria.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">19.2 </span> Any amendment to this Contract must be agreed to by the parties in writing.
            </div>
            <br/>
            <div class="secondary_align">
            <span class="secondary_point">19.3 </span> <span class="val">The obligations of the parties under clauses 3, 13, 15, 16.4 and 17 survive the termination of this Contract.</span>
            </div>
            <br/>
          </div>
          <h3 class="title"><span class="main_point">20</span> Definitions</h3>
          <p>
            <span class="secondary_point">20.1 </span> In this document unless the context requires otherwise:
          </p>
          <ul class="no_markers">
            <li>
              <b>Charges </b> means the Fee and (if applicable) the Travel Expense Reimbursement Amount.
            </li>
            <br/>
            <li>
              <b>Contract </b> means the contract between the Locum and the Pharmacy created in accordance with the Locum
              Terms of Access and the Pharmacy Terms of Access contained on Locumate’s website on these Terms.
            </li>
            <br/>
            <li>
              <b>Confidential Information </b> includes <br/>
              <br/>
              <ul class="no_markers">
                <li class="d-flex">
                  <span>(a)</span>
                  <span class="val">the terms of this Contract;</span>
                </li>
                <li class="d-flex">
                  <span>(b)</span>
                  <span class="val"
                  >the terms on which the Pharmacy contracts with its clients, customers, or suppliers;
                  </span>
                </li>
                <li class="d-flex">
                  <span>(c)</span>
                  <span class="val"
                  >business information relating to the Pharmacy’s operations, affairs, current and future business plans and models, data bases, methodologies, manuals, existing or contemplated products and services, advertising manuals, ideas, concepts, trade secrets, designs, copyrights, patents, design improvements, all financial, accounting, marketing and technical information, financial projections, customer lists and customer files, data surveys, research, reports, pricing schedules, pitches, tenders, know-how, computer software including the source code, technology, operating procedures and other information, used by or relating to the Pharmacy; and
                  </span>
                </li>
                <li class="d-flex">
                  <span>(d)</span>
                  <span class="val"
                  >any other information which by its nature, or because the Locum has been told that it is confidential, is or could reasonably be expected to be confidential to the Pharmacy or its customers.
      </span
      >
                </li>
              </ul>
              <b>This definition excludes any information which: </b>
              <br/>
              <br/>
              <ul class="no_markers">
                <li class="d-flex">
                  <span>(a)</span>
                  <span class="val"
                  >has lawfully become part of the public domain other than as a result of a breach of this Contract;
                  </span>
                </li>
                <li class="d-flex">
                  <span>(b)</span>
                  <span class="val"
                  >was known by the Locum prior to the Pharmacy disclosing the information; or
                  </span>
                </li>
                <li class="d-flex">
                  <span>(c)</span>
                  <span class="val"
                  >the Locum is required by law to disclose.
                  </span>
                </li>
              </ul>
            </li>
            <br/>
            <li>
              <b>Engagement </b> means the engagement by the Pharmacy of the Locum to provide the Services in accordance
              with this Contract.
            </li>
            <br/>
            <li>
              <b>Fee </b> means the fee specified in the Request for Services.
            </li>
            <br/>
            <li>
              <b>GST Act </b> means the <i>A New System (Goods and Services Tax) Act 1999</i> (Cth).
            </li>
            <br/>
            <li>
              <b>Indemnified Person </b>means the Pharmacy and each partner, shareholder, director, officer, employee,
              contractor and representative of the Pharmacy.
            </li>
            <br/>
            <li>
              <b>Locum </b> means the pharmacist that has accepted the Request for Services in respect of the Engagement.
            </li>
            <br/>
            <li>
              <b>Locumate </b> means S.S.K.N. Nominees Pty Ltd ABN 73 619 569 121 trading as Locumate.
            </li>
            <br/>
            <li>
              <b>Locumate Platform </b> means the online platform and mobile application owned and operated by Locumate.
            </li>
            <br/>
            <br/>
            <li>
              <b>Locumate Website </b> means our website at
              <a href="https:\www.locumate.com.au">www.locumate.com.au.</a>
            </li>
            <br/>
            <li>
              <b>Locum Terms of Access </b>Access means the Locum Terms of Access published on the Locumate Website.
            </li>
            <br/>
            <li>
              <b>Pharmacy </b>means the pharmacy that has made the Request for Services in respect of the Engagement.
            </li>
            <br/>
            <li>
              <b>Pharmacy Terms of Access </b>means the Pharmacy Terms of Access published on the Locumate Website.
            </li>
            <br/>
            <li>
              <b>Premises </b>means the premises of the Pharmacy identified in the Request for Services.
            </li>
            <br/>
            <li>
              <b>Premises </b>means the premises of the Pharmacy identified in the
              Request for Services.
            </li>
            <br/>
            <li>
              <b>Request for Services </b>means the request by the Pharmacy for the Services made through the Locumate
              Platform in accordance with the Pharmacy Terms of Access, which has been accepted by the Locum in accordance
              with the Locum Terms of Access.
            </li>
            <br/>
            <li>
              <b>Services </b>means the locum services specified in the Request for Services.
            </li>
            <br/>
            <li>
              <b>Shift </b>means the duration of the Engagement as specified in the Request for Services.
            </li>
            <br>
            <li>
              <b>Travel Expense Reimbursement Amount </b>means the daily amount that the Pharmacy must (if applicable) pay
              the Locum in respect of travel in accordance with clause 10.3.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted, inject} from "vue";

import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {IonToolbar, IonButton, IonButtons, IonIcon} from "@ionic/vue";

import {useStore} from "vuex";

import {useRouter, useRoute} from "vue-router";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    // const $route = useRoute()
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const routeName = $route.name;
    console.log("🚀 ~ setup ~ routeName:", routeName)
    const backPage = $store.getters.getLastPage;
    

    const setPageClassGlobal = inject("setPageClassGlobal");

    const travelCompensation = process.env.VUE_APP_TRAVEL_COMPENSATION;

    const goBack = () => {
      if (routeName === "terms_and_conditions2") {
        $router.push({
          name: "auth",
        });
      }else if(routeName === "terms_and_conditions_guest_shift"){
        $router.back();
      }else if(routeName === "terms_and_conditions_update"){
        $router.push({
          name: "search",
        });

      } else {
        if(userData.role === 'job-seeker'){
          if(backPage === '/job-seeker/index'){
                $router.push({
                name: "job_seeker_index",
            });
            }else{
                $router.push({
                name: "profile_job_seeker_setting",
            });
            }
        }else{
            $router.push({
            name: "common_about",
          });
        }
       
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_privacy_terms_page");
    });

    return {
      goBack,
      userRole,
      routeName,
      travelCompensation,
      backPage
    };
  },
};
</script>
